module.exports = {
      id: "user-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#user",
      toString: function () {
        return this.url;
      }
    }